import { z } from 'zod'

export const AiAutomationPlaygroundSchemas = {
  startSession: {
    request: z.object({
      session_id: z.string(),
      user_message: z.string(),
    }),
    query: z
      .object({
        client_id: z.string().optional(),
      })
      .optional(),
    path: z.undefined(),
    response: z.object({
      session_id: z.string(),
    }),
  },
  startSessionByGoal: {
    request: z.object({
      session_id: z.string(),
      goal_id: z.string(),
    }),
    response: z.object({
      session_id: z.string(),
    }),
    query: z
      .object({
        client_id: z.string().optional(),
      })
      .optional(),
    path: z.undefined(),
  },
  sendMessage: {
    request: z.object({
      session_id: z.string(),
      user_message: z.string(),
    }),
    query: z
      .object({
        client_id: z.string().optional(),
      })
      .optional(),
    path: z.undefined(),
    response: z.object({
      session_id: z.string(),
    }),
  },
}
